import React, { useState } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import useErrorState from '../../../utils/errors/useErrorState';
import { errorMessages } from '../../../utils/errors/constants';

const ChildQuestions = ({
  index,
  rendering,
  fields,
  dispatch,
  displayErrors,
  updateChildState,
  handleToggle,
  childComplete,
}) => {
  const [questionError, setQuestionError] = useErrorState(
    `${rendering.uid}_${index}`,
    `${fields.name?.value}_${index}`,
    fields
  );
  const [displayQuestionErrors, setDisplayQuestionErrors] = useState(false);

  const disableSubmit =
    questionError && Object.values(questionError).some(e => e.type === errorMessages.EMPTY);

  const customiseComponent = component => {
    const componentType = component?.props?.rendering?.componentName;
    const reduxValuePath = {
      value: component.props.fields?.reduxValuePath?.value?.replace('{index}', index),
    };
    const reduxDispatchType = {
      value: component.props.fields?.reduxDispatchType?.value,
      payload: { index },
    };

    const onError = errorMessage => {
      if (errorMessage) {
        dispatch({
          type: reduxDispatchType.value,
          payload: { index, value: null },
        });
        setQuestionError(prevErrors => ({
          ...prevErrors,
          [component.key]: {
            ...errorMessage,
            name: component.props.fields?.testid?.value,
          },
        }));
        updateChildState(index, { errors: true });
      } else {
        setQuestionError(prevErrors => {
          const newError = { ...prevErrors };
          delete newError[component.key];
          if (Object.keys(newError).length === 0) {
            updateChildState(index, { errors: false });
          }
          return newError;
        });
      }
    };

    const openNext = () => {
      if (!childComplete[index]?.errors) {
        handleToggle(index, false);
        handleToggle(index + 1, true);
      } else {
        setDisplayQuestionErrors(true);
      }
    };

    return {
      ...component,
      props: {
        ...component.props,
        fields: {
          ...component.props.fields,
          reduxValuePath,
          reduxDispatchType,
        },
        rendering: {
          ...component.props.rendering,
          uid: `${component.props.rendering.uid}_${index}`,
        },
        componentName: `${component.props.rendering.uid}-${index}`,
        onClick: componentType === 'SubmitButton' ? openNext : undefined,
        hasError: disableSubmit,
        errorMessage: Object.values(questionError ?? {}).pop() || '',
        displayErrors: displayErrors || displayQuestionErrors,
        onError,
      },
    };
  };

  return (
    <div className="vds-form__group vds-form__group--checklist vds-form__group--checklist-limit-width vds-margin-left-spacing-4">
      <Placeholder
        name="child-details-questions"
        rendering={rendering}
        render={components => components.map(customiseComponent)}
      />
    </div>
  );
};

export default ChildQuestions;
